import React, { useState } from 'react';
import { ButtonBase, Menu, MenuItem } from '@material-ui/core';
import {
  HandIcon,
  MoreVertIcon,
  RefreshCwIcon02,
  UsersLeftIcon,
} from '../../../../../../assets/icons';
import { claimTypeEnums } from '../../../Utilities/Utilities';
import { useLeadXchangeData } from '../Context/LeadXchangeData';

import SendToRotationDialog from '../Dialogs/SendToRotationDialog';
import LeadsXChangeReassignDialog from '../Dialogs/LeadsXChangeReassignDialog';
import { showError, showSuccess } from '../../../../../../Helper';
import { LeadXchangeClaimLead } from '../../../../../../Services/LeadXChangeServices/LeadXChangeServices';

import './LeadXChangeCardActions.scss';
export default function LeadXChangeCardActions({
  leadData,
  isClaimed,
  reload,
  setLoading,
}) {
  const { userInfo } = useLeadXchangeData();
  const { sharedLeadId } = leadData;

  const [openSendToRotationDialog, setOpenSendToRotationDialog] =
    useState(false);
  const [openReassignDialog, setOpenReassignDialog] = useState(false);
  const handleClaimLead = async () => {
    const body = {
      shareLeadIds: [sharedLeadId],
      claimedUserInfo: {
        ...userInfo,
      },
      claimType: claimTypeEnums.NormalClaim,
    };
    try {
      await LeadXchangeClaimLead(body);
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        showSuccess('Claimed successfully');
        reload();
      }, 4000);
    } catch (error) {
       showError(error.message || "Something went wrong");
    }
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    setAnchorEl({
      top: rect.top + 25,
      left: rect.left + 15,
    });
  };
  const menuOptions = [
    {
      icon: (
        <RefreshCwIcon02
          width='16'
          height='16'
          fill='#667085'
        />
      ),
      label: 'Sent to rotation',
      handleOnclick: () => {
        setOpenSendToRotationDialog(true);
      },
    },
    {
      icon: (
        <UsersLeftIcon
          width='16'
          height='16'
          fill='#667085'
        />
      ),
      label: 'Reassign lead',
      handleOnclick: () => {
        setOpenReassignDialog(true);
      },
    },
  ];
  return (
    <>
      <ButtonBase
        className='leadxchange-card-claim'
        onClick={handleClaimLead}
        disabled={isClaimed}
      >
        <HandIcon
          width='20'
          height='20'
          fill={'#344054'}
        />
        <span className='leadxchange-card-claim-text'>Claim</span>
      </ButtonBase>
      <ButtonBase
        aria-controls='more-button'
        aria-haspopup='true'
        aria-label='more-button'
        id='more-button'
        onClick={handleClick}
        disabled={isClaimed}
      >
        <MoreVertIcon
          width='20'
          height='20'
          fill={anchorEl ? '#667085' : '#98A2B3'}
        />
      </ButtonBase>
      <Menu
        id='more-button'
        PaperProps={{ elevation: 0 }}
        MenuListProps={{ className: 'customMenuList' }}
        anchorReference='anchorPosition'
        anchorPosition={
          anchorEl ? { top: anchorEl.top, left: anchorEl.left } : undefined
        }
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {menuOptions.map(({ label, icon, handleOnclick }) => (
          <MenuItem
            disableRipple
            key={label}
            onClick={(event) => {
              event.stopPropagation();
              handleOnclick();
              handleClose();
            }}
            className='option-item'
          >
            {icon}
            <span>{label}</span>
          </MenuItem>
        ))}
      </Menu>
      {openSendToRotationDialog && (
        <SendToRotationDialog
          leadData={leadData}
          open={openSendToRotationDialog}
          onClose={() => setOpenSendToRotationDialog(false)}
          reload={reload}
          setLoading={setLoading}
        />
      )}

      {openReassignDialog && (
        <LeadsXChangeReassignDialog
          open={openReassignDialog}
          onClose={() => setOpenReassignDialog(false)}
          leadData={leadData}
          reload={reload}
          setLoading={setLoading}
        />
      )}
    </>
  );
}
